export default __webpack_public_path__ + "static/media/pt-img.ee914151.webp";